// axiosInstance.ts
import { fetchAuthSession } from "aws-amplify/auth";
import axios from "axios";

// Create an Axios instance
const axiosInstance = axios.create({});

// Add a request interceptor
axiosInstance.interceptors.request.use(
  async (config) => {
    // Retrieve the token
    const token = await getToken();

    // If the token exists, add it to the headers
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    // Handle the error
    return Promise.reject(error);
  }
);

async function getToken() {
  const session = await fetchAuthSession();
  return session?.tokens?.idToken || "";
}

export default axiosInstance;
